<script>
import { EventActivityType } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      redirectRoute: { name: 'EventActivityType List' }
    }
  },
  computed: {
    service() {
      return EventActivityType
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          modelPath: [this, 'form', 'name'],
          multilingual: true
        }),
        new fields.Input({
          label: 'Slug',
          disabled: true,
          modelPath: [this, 'form', 'slug'],
          condition: !!this.form.id
        })
      ]
    }
  }
}
</script>
